const uncheckOtherCheckboxes = function(elementNotToUncheck) {
    const checkboxElements = document.querySelectorAll('.header-menu__sub-menu-checkbox');
    const checkboxElementsLength = checkboxElements.length;
    if (checkboxElementsLength == 0) {
        return;
    }
    for (let index = 0; index < checkboxElementsLength; index++) {
        const checkboxElement = checkboxElements[index];
        if (checkboxElement == elementNotToUncheck) {
            continue;
        }
        checkboxElement.checked = false;
    }
}

const setupAutoconverse = function() {
    const forms = document.querySelectorAll('.autoconverse__form');
    const formsLength = forms.length;
    if (formsLength == 0) {
        return;
    }
    for (let index = 0; index < formsLength; index++) {
        const form = forms[index];
        form.addEventListener('submit', function(event) {
            event.preventDefault();
            autoSearch.showSearch(event, '784b3fba-bcd6-42cd-b185-29302fb90a72', form.querySelector('.autoconverse__input').value);
            return false;
        });
    }
}

export default function() {
    const checkboxElements = document.querySelectorAll('.header-menu__sub-menu-checkbox');
    const checkboxElementsLength = checkboxElements.length;
    if (checkboxElementsLength == 0) {
        return;
    }
    for (let index = 0; index < checkboxElementsLength; index++) {
        const checkboxElement = checkboxElements[index];
        checkboxElement.addEventListener('change', function(event) {
            if (event.target.checked) {
                uncheckOtherCheckboxes(checkboxElement);
            }
        });
    }

    setupAutoconverse();
}


// WEBPACK FOOTER //
// ./resources/assets/js/mega-menu/touch.js